// The active client's brand (name, logo, contacts, copy). Generated per client by scripts/brand.js;
// edit src/clients/<id>/brand.json, not this folder.
import brand, { tokens } from './active'

// Fills {placeholders} in brand copy; {name} is always the short brand name.
export const brandText = (template, values = {}) =>
    String(template || '').replace(/\{(\w+)\}/g, (match, key) =>
        key in values ? values[key] : key === 'name' ? brand.name : match)

export const whatsappLink = (text) =>
    `https://wa.me/${brand.contact.whatsapp}` + (text ? `?text=${encodeURIComponent(text)}` : '')

// Link for sharing a product: https://<shop>/p/{id}. Firebase Hosting redirects /p/{id} to the backend's
// /share/item/{id} page (photo, name and price for WhatsApp previews), which sends people on to the product page.
export const productShareLink = (id) =>
    String(brand.siteUrl || window.location.origin).replace(/\/+$/, '') + '/p/' + encodeURIComponent(id)

export { tokens }
export default brand
